// Generated by CoffeeScript 1.12.6
var sites;

require('angular-resource');

sites = require('goodeggs-sites');

module.exports = __filename;

angular.module(__filename, ['ngResource']).factory('LineItem', [
  '$resource', '$window', function($resource, $window) {
    var LineItem, baseUrl;
    baseUrl = (sites.getUrl('ops-purchase-orders-api', $window.settings)) + "/v1/line_items";
    LineItem = $resource(baseUrl + "/:id", {
      id: '@_id'
    }, {
      update: {
        method: 'PUT'
      },
      save: {
        method: 'POST'
      },
      query: {
        method: 'GET',
        isArray: true
      },
      get: {
        method: 'GET'
      },
      destroy: {
        method: 'POST',
        url: baseUrl + "/:id/destroy"
      },
      receive: {
        method: 'POST',
        url: baseUrl + "/:id/receive"
      }
    });
    return LineItem;
  }
]);
